<div *ngIf="seoPropositions" class="seo-proposition-messages">
	<h2 class="ico-star proposition" *ngFor="let proposition of seoPropositions; trackBy: trackByFn">
		{{ proposition }}
	</h2>
</div>
